<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
import { EventBus } from '../../../utils/event-bus';
  export default Vue.extend({
    name: 'EditVRWordCloud',
    data() {
      return {
        keywords: []
      };
    },
    props: {
      keywordData: []
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    methods: {
      handleSaveKeywrods: async function() {
        await this.$store.dispatch('saveLiveDiscussionSettings', { id: this.getCurrentDiscussion.id, keywords: JSON.stringify(this.keywords)});
        const toast = {
          type: "Success",
          message: "The wordcloud has been updated!"
        };
        EventBus.$emit('createToast', toast);
        this.$emit('close');
      },
    },
    mounted: async function() {
      this.keywords = JSON.parse(this.getCurrentDiscussion.keywords);
    }
  });
</script>
<template>
  <pl-dialog size="lg" title="Edit WordCloud" @close="$emit('close')" :disableOutsideClick="true">
    <div class="relative w-full h-full flex flex-col pb-5 space-y-3 px-6">
      <div class="bg-gray-100 rounded-t border border-solid border-gray-200 w-full px-6 py-3.5 text-gray-700 text-sm">
        <i class="fa-solid fa-circle-info mr-1.5"></i>
        <span>A refined word cloud is better. We</span> 
        <span class="font-semibold">recommend</span> removing keywords that are too generic to <span class="font-semibold">provide relevant </span>insights.
      </div>
    <div class="flex-grow overflow-hidden table-height  mb-3 overflow-y-auto">
      <div class="relative w-full h-full ">
        <table class="table-auto w-full">
          <thead class="bg-gray-100 border border-solid text-sm rounded">
            <tr>
              <th class="text-center w-1/12 text-sm text-gray-700 py-3"></th>
              <th class="text-left py-3">Keyword</th>
              <th class="text-right px-6 w-2/12 py-3">Occurrences</th>
            </tr>
          </thead>
          <tbody class="bg-white border border-solid text-gray-700 text-sm rounded">
            <tr v-for="(word, index) in Object.keys(keywords)" class="border-b" :key="index">
              <td class="text-center py-2 font-semibold" v-if="word !== 'l'">
                <input type="checkbox" :checked="!keywords[word].removed"  @click="keywords[word].removed = !keywords[word].removed" />
              </td>
              <td v-if="word !== 'l'" @click="keywords[word].removed = !keywords[word].removed" class="py-2 cursor-pointer hover:underline">
                {{ word }}
              </td>
              <td class="text-right px-6 py-2" v-if="word !== 'l'">
                {{ keywords[word].freq }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="w-full flex justify-between items-center">
      <button @click="$emit('close')" class="px-4 py-2 bg-gray-50 border border-solid border-gray-200 hover:bg-gray-100 rounded text-gray-800">Cancel</button>
      <button @click="handleSaveKeywrods()" class="px-4 py-2 bg-primary border border-solid border-primary hover:bg-primary-dark hover:border-primary-dark rounded text-white">Save Keywords</button>
    </div>
  </div>
</pl-dialog>

</template>
<style lang="css">
  .table-height {
    height: 200px;
  }
</style>

<style scoped>
  input[type='checkbox'] {
    margin-top: 4px;
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    border-color: #72ccd7;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72ccd7;
    margin-bottom: 5px;
    margin-top: 4px;
    border-color: #72ccd7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
</style>





// WEBPACK FOOTER //
// EditVRWordCloud.vue?f7e0ddc0